export enum CivilStatus {
  SINGLE = 'SINGLE',

  MARRIED = 'MARRIED',

  CONCUBINAGE = 'CONCUBINAGE',

  OTHERS = 'OTHERS',
}
